import { useState } from 'react';
import { isSmartPhone, RoundedOffAmount } from '../../utilities/helper';
import TransactionPokerItemWeb from './index_web';
import TransactionPokerItemMWeb from './index_mWeb';
import React from 'react';

interface Props {
  item: any;
  isPoker: boolean;
}

const TransactionPokerItem = ({ item, isPoker }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const { amount = 0, gameId = '', transfer = false } = item;

  const newAmount = RoundedOffAmount(amount);

  const isTransfer = transfer && !gameId;
  return (
    <>
      {isSmartPhone ? (
        <TransactionPokerItemMWeb
          item={item}
          newAmount={newAmount}
          isTransfer={isTransfer}
          isPoker={isPoker}
          expanded={expanded}
          setExpanded={setExpanded}
        />
      ) : (
        <TransactionPokerItemWeb
          item={item}
          isPoker={isPoker}
          newAmount={newAmount}
          isTransfer={isTransfer}
        />
      )}
    </>
  );
};
export default React.memo(TransactionPokerItem);
